// extracted by mini-css-extract-plugin
module.exports = {"address-card-preview":"address-card-preview--3NWwM66b0Z","addressCardPreview":"address-card-preview--3NWwM66b0Z","title":"title--1DYsboSBtJ","flags":"flags--22ItSsGkyW"};